<template>
  <div class="flex flex-col gap-4">
    <!-- Filters -->
    <V4HomeCourseFilters
      :course-filters="true"
      :show-high-low-progress="true"
    />
    <!-- end filters -->
    <V4HomeCourses />
  </div>
</template>

<script setup>
import { useHomeCoursesStore } from "@/stores/home/useHomeCourses.store";
import { onActivated, onMounted, defineOptions } from "vue";
import V4HomeCourses from "./V4HomeCourses.vue";
import V4HomeCourseFilters from "./filters/V4HomeCourseFilters.vue";

defineOptions({
  inheritAttrs: false,
});

const homeCoursesStore = useHomeCoursesStore();

const handleFetchCourses = (fetchCourseProgress = false) => {
  homeCoursesStore.handleFetchCoursePaginated(fetchCourseProgress);
};

const handleFetchCoursesAndProgress = () => {
  handleFetchCourses(true);
};

onMounted(() => {
  handleFetchCourses();
});

onActivated(() => {
  handleFetchCoursesAndProgress();
});
</script>

<style lang="css" scoped>
.slide-fade-enter-active {
  transition: all 0.2s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
</style>
